/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, {Fragment, useState} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup} from 'reactstrap';
import PropTypes from "prop-types";
import {_delete, _postDelete} from "../Api";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTrashAlt, faWindowClose} from '@fortawesome/free-solid-svg-icons'
import Loader from "./Loader";

const ModalDelete = (props) => {
    const {
        buttonLabel,
        className,
        color,
        items,
        selected,
        db,
        buttonClass,
        handleOnDelete,
        listValue
    } = props;
    const [modal, setModal] = useState(false);
    const [backdrop, setBackdrop] = useState(true);
    const [keyboard, setKeyboard] = useState(true);
    const [data, setData] = useState({});
    const [keys, setKeys] = useState([]);
    const [id, setId] = useState([]);
    const [loading, setLoading] = useState(false);

    const toggle = () => {
        setModal(!modal)
        setData(selectedData)
    };

    const selectedData = () => {
        let jsonData = [];
        let keyData = [];
        let idData = [];

        if (typeof selected === 'number') {
            jsonData.push(items[selected])
            keyData.push(selected)
            idData.push(items[selected].id)
        } else {
            selected.map((val, index) => {
                if (val) {
                    jsonData.push(items[index])
                    keyData.push(index)
                    idData.push(items[index].id)
                }
            })
        }
        setData(jsonData);
        setKeys(keyData);
        setId(idData);
    }

    const deleteData = () => {
        setLoading(true);
        const countData = data.length;
        if (countData === 1) {
            _delete(db, id[0]).then(res => {
                if (res.result === 'success') {
                    handleOnDelete(keys);
                }
                toggle();
                setLoading(false);
            })
        } else {
            _postDelete(db, id).then(res => {
                if (res.result === 'success') {
                    handleOnDelete(keys);
                }
                toggle();
                setLoading(false);
            })
        }
    }

    const changeBackdrop = e => {
        let value = e.target.value;
        if (value !== 'static') {
            value = JSON.parse(value);
        }
        setBackdrop(value);
    }

    const changeKeyboard = e => {
        setKeyboard(e.currentTarget.checked);
    }

    return (
        <div>
            <Form inline onSubmit={(e) => e.preventDefault()}>
                <Button outline color={color} onClick={toggle} className={buttonClass}>
                    <FontAwesomeIcon icon={faTrashAlt}/> {buttonLabel}</Button>
            </Form>
            <Modal isOpen={modal} toggle={toggle} className={className} backdrop={backdrop} keyboard={keyboard}>
                {!loading ?
                    <Fragment>
                        <ModalHeader toggle={toggle}>Are you sure you want to DELETE the following data ?</ModalHeader>
                        <ModalBody>
                            <table className="table table-hover table-striped table-hover">
                                <tbody className="table-hover">
                                {data &&
                                Object.values(data).map((item, i) => {
                                    return (
                                        <tr key={i}>
                                            {Object.values(item).map((field, index) => {
                                                return (
                                                    <td key={index}>{field}</td>
                                                )
                                            })}
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={deleteData}><FontAwesomeIcon icon={faTrashAlt}/> Yes, Delete</Button>{' '}
                            <Button color="secondary" onClick={toggle}><FontAwesomeIcon
                                icon={faWindowClose}/> Cancel</Button>
                        </ModalFooter>
                    </Fragment>
                    :
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <Loader isLoading={true}/>
                            </div>
                        </div>
                    </div>
                }
            </Modal>
        </div>
    );
}

ModalDelete.propTypes = {
    onCloseClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    show: PropTypes.any,
    size: PropTypes.any,
    scrollable: PropTypes.bool,
}

export default ModalDelete;